import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getDiscount } from "../../services/discountService";
function DiscountBanner() {
	const [isVisible, setIsVisible] = useState(false);
	const [discount, setDiscount] = useState("");

	// Hide the banner when the close button is clicked
	const handleClose = () => {
		setIsVisible(false);
	};

	useEffect(() => {
		getDiscount()
			.then((res) => {
				if (res.data.data.discountPrice !== "") {
					setIsVisible(true);
					setDiscount(res.data.data);
				} else {
					setIsVisible(false);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	if (!isVisible) return null;

	return (
		<Box
			sx={{
				width: "100%",
				borderBottom: "1px solid #cacaca",
				backgroundColor: "#50e4de", // ffecb3
				color: "#eb1a1a", // e41387
				padding: "10px 0",
				textAlign: "center",
				position: "sticky",
				top: 0,
				zIndex: 1000,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<div className='scrolling-banner'>
				<Typography className='scroll' variant='body1' sx={{ fontWeight: "bold", py: 0 }}>
					🎉 Offer!! Get up to {discount.discountType === "amount" ? "₹" : ""} {discount.discountPrice}
					{discount.discountType === "percentage" ? "%" : "/-"} off on all projects! 🎉
					Offer!! Get up to {discount.discountType === "amount" ? "₹" : ""} {discount.discountPrice}
					{discount.discountType === "percentage" ? "%" : "/-"} off on all projects! 🎉
					Offer!! Get up to {discount.discountType === "amount" ? "₹" : ""} {discount.discountPrice}
					{discount.discountType === "percentage" ? "%" : "/-"} off on all projects! 🎉
				</Typography>
			</div>
			<IconButton
				aria-label='close'
				onClick={handleClose}
				sx={{
					color: "#d32f2f",
					padding: "0",
					mr: 2,
				}}
			>
				<CloseIcon />
			</IconButton>
		</Box>
	);
}

export default DiscountBanner;
